import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取所有配置
export const getBaseList = params => {
    return get("/admin/config", params);
};
// 获取协议
export const getruleMsg = params => {
    return get(`/admin/rule/${params.id}`);
};
// 修改协议
export const editruleMsg = params => {
    return put(`/admin/rule/${params.id}`, params);
};
// 新增城市
export const addCity = params => {
    return post("/admin/citys", params);
};
// 修改城市信息
export const editCity = params => {
    return put(`/admin/citys/${params.id}`, params);
};
// 删除城市
export const deleteCity = params => {
    return del(`/admin/citys/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/base.js